/**
 * @generated SignedSource<<312c56f0d63b965574059bc5cdc62fb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetActivityManagementPlayerRateOptions_Booking$data = {
  readonly startSlot: {
    readonly durationPlayerRates?: ReadonlyArray<{
      readonly rate: {
        readonly id: string;
        readonly name: string;
      };
      readonly totalDurationPrice: number | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "useGetActivityManagementPlayerRateOptions_Booking";
};
export type useGetActivityManagementPlayerRateOptions_Booking$key = {
  readonly " $data"?: useGetActivityManagementPlayerRateOptions_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetActivityManagementPlayerRateOptions_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "duration"
    },
    {
      "kind": "RootArgument",
      "name": "playerCount"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetActivityManagementPlayerRateOptions_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "durationPlayerRates",
              "args": [
                {
                  "kind": "Literal",
                  "name": "highestPrecedentOnly",
                  "value": false
                },
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "CUSTOMER"
                }
              ],
              "concreteType": "SlotRate",
              "kind": "LinkedField",
              "name": "playerRates",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "duration",
                      "variableName": "duration"
                    },
                    {
                      "kind": "Variable",
                      "name": "playerCount",
                      "variableName": "playerCount"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "totalDurationPrice",
                  "storageKey": null
                }
              ],
              "storageKey": "playerRates(highestPrecedentOnly:false,type:\"CUSTOMER\")"
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "fe7b982a9fae32a876daf29a063ae1bb";

export default node;
